import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { AppLayoutModule } from './app-layout/app-layout.module';
import { UiModule } from 'src/app/ui/ui.module';
import { HttpClient, provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS  } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader, TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader';
import { HTTPListener } from './httpInterceptor';
import { AuthGuardService } from './services/auth/auth-guard.service';
import { AuthService } from './services/auth/auth.service';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { ToastComponent } from './app-layout/toast/toast.component';
import { ModalErrorService } from './services/shared/modal-error.service';
import { ModalErrorComponent } from './app-layout/modal-error/modal-error.component';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JiraUsersComponent } from './user/jira-users/jira-users.component';
import { JiraUserCreationSuccessComponent } from './user/jira-users/jira-user-creation-success/jira-user-creation-success.component';
import { PacmanComponent } from './easter-egg/pacman/pacman.component';
import { FireworksComponent } from './easter-egg/fireworks/fireworks.component';


registerLocaleData(localeIt);

const RxJS_Services = [HTTPListener];

@NgModule({ declarations: [AppComponent, ToastComponent, ModalErrorComponent, JiraUsersComponent, JiraUserCreationSuccessComponent, PacmanComponent, FireworksComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        NgbModule,
        AppLayoutModule,
        UiModule,
        NgbToastModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory
            },
        }),
        BrowserAnimationsModule], 
        providers: [
        ...RxJS_Services,
        [AuthGuardService, AuthService, ModalErrorService],
        { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
        { provide: localeIt, useValue: 'it-IT' },
        JwtHelperService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HTTPListener,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: TRANSLATE_HTTP_LOADER_CONFIG,
            useValue: { 
                prefix: './assets/i18n/', 
                suffix: '.json' 
            }
        }
    ] })
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader();
}
